import actions from './actions';
import getters from './getters';
import mutations from './mutations';


const getDefaultItemLine = () =>({

    account: null,
    description: null,
    discount: null,
    inventory: null,
    item: null,
    prices: [],
    product: {
      id: null,
      type: null,
      unit: null,
      uvc : null,
      name: null,
      account: null,
    },
    discount: {
      amount: null,
      creditType : null,
      netType: null,
      value: null
    },
    productTaxes : [],
    qty: 1,
    subTotal : null,
    subTotalBrut: null,
    taxAmount: null,
    taxableAmount: null,
    uuid: null,
    editState: false,
})

const getDefaultState = () => ({
  invoice : {
    id : null,
    invNumber: null,
    customer: null,
    billingContact: null,
    shippingContact: null,
    billingAddress: null,
    shippingAddress: null,
    credit: null,
    adjustment: null,
    reference: null,
    salesOrders: [],
    invoiceNumberReference: null,
    balance: null,
    rep : null,
    date : null,
    dueDate: null,
    deliveryFee: null,
    notes: null,
    subTotal: null,
    total: null,
    term: null,
    lines : [],
    currency: null,
    paymentTypes: [],
    taxes: null,
    purchaseOrder: null,
    showTierceAgencyOutstanding: true,
    status: null,
    creditNotes: [],
    creditNote: null,
    discount : null,
    detailedPrices: true,
  },
  creditNotes : [],
  invoiceItemsLoading : false,
  // paymentTypes : [
  //   {
  //     type : "CREDIT_CARD",
  //     icon : "mdi mdi-credit-card",
  //     id :1
  //   },{
  //     type : "CHECK",
  //     icon : "mdi mdi-cash-multiple",
  //     id :2
  //   },{
  //     type : "BANK_TRANSFER",
  //     icon : "mdi mdi-cash-multiple",
  //     id :3
  //   }
  // ],
  defaultItem : getDefaultItemLine(),
  searchedCustomers : [],
  customerContacts : null,
  customersLoading : false,
  itemsLoading : false,
  terms : [],
  invoiceLoading : false,
});


export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
